/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { cssMap } from '@compiled/react';
import Skeleton from '@atlaskit/skeleton';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

const loadingMessage = defineMessage({
	id: 'servicedesk-capacity.capacity-list-skeleton.loading',
	defaultMessage: 'Loading capacity data',
	description: 'Accessible loading message for screen readers while capacity list is loading',
});

const styles = cssMap({
	contentRow: {
		width: '100%',
		height: '64px',
	},
});

export type CapacityListSkeletonProps = {
	rowCount?: number;
};

export const CapacityListSkeleton = ({
	rowCount = 6,
}: CapacityListSkeletonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.200" testId="capacity.ui.capacity-list.capacity-list-skeleton">
			<VisuallyHidden>{formatMessage(loadingMessage)}</VisuallyHidden>

			{/* Agent row skeletons */}
			{Array.from({ length: rowCount }).map((_, index) => (
				<Box key={index} xcss={styles.contentRow}>
					<Skeleton isShimmering width="100%" height="100%" borderRadius={token('radius.large')} />
				</Box>
			))}
		</Stack>
	);
};
